import { render } from "./GPSAdmin.vue?vue&type=template&id=0a715c27&scoped=true"
import script from "./GPSAdmin.vue?vue&type=script&lang=js"
export * from "./GPSAdmin.vue?vue&type=script&lang=js"

import "./GPSAdmin.vue?vue&type=style&index=0&id=0a715c27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a715c27"]])

export default __exports__